import SkeletonHeader from "./SkeletonHeader";
import IconSkeleton from "./IconSkeleton";

interface SkeletonCardProps {
  wrapperClassName?: string;
  className?: string;
  showIcon?: boolean;
  titleWidth?: string;
  valueWidth?: string;
  lines?: number;
  iconSide?: "left" | "right";
}

const SkeletonCard = ({
  wrapperClassName = "col-12 col-md-6 col-xl-3",
  className = "",
  showIcon = true,
  titleWidth = "60%",
  valueWidth = "50%",
  lines = 1,
  iconSide = "right"
}: SkeletonCardProps) => {
  return (
    <div className={`${wrapperClassName} ${className}`.trim()}>
      <div className="apple-card gestalt-group group border-0 shadow-sm rounded-5 p-5 h-100 bg-white skeleton-card">
        <div className="d-flex justify-content-between gap-3 align-items-center">
          {showIcon && iconSide === "left" && (
            <div className="d-flex align-items-start justify-content-center rounded">
              <IconSkeleton size={64} borderRadius={20} />
            </div>
          )}

          <div className="w-100">
            <SkeletonHeader titleWidth={titleWidth} subtitleWidth={valueWidth} />
            {Array.from({ length: lines }).map((_, index) => (
              <div
                key={index}
                className="mb-2 skeleton-wave-block"
                style={{
                  height: 12,
                  width: `${40 + (index % 2) * 20}%`,
                  borderRadius: 8,
                  backgroundColor: "rgba(226, 232, 240, 0.75)",
                }}
              />
            ))}
          </div>
          {showIcon && iconSide === "right" && (
            <div className="d-flex align-items-start justify-content-center rounded">
              <IconSkeleton size={64} borderRadius={20} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
